import React, { Fragment } from 'react';
import MetaTags from 'react-meta-tags';

import Loading from '../blocks/loading/Loading';
import Header from '../blocks/header/Header';
import Footer from '../blocks/footer/Footer';

import PageTitlePortfolio from '../blocks/page-title/PageTitlePortfolio';
import Gallery from '../blocks/gallery/Gallery';

const Portfolio = () => {
    document.body.classList.add( 'archive' );
    
    return (
        <Fragment>
            <MetaTags>
                <meta charSet="UTF-8"/>
                <title>Explore My Portfolio</title>

                <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <meta name="robots" content="index, follow, noodp" />
                <meta name="googlebot" content="index, follow" />
                <meta name="google" content="notranslate" />
                <meta name="format-detection" content="telephone=no" />
            </MetaTags>

            <Loading />

            <Header />

            <main id="main" className="site-main">
                <PageTitlePortfolio />

                <div id="page-content" className="spacer p-top-xl">
                    <div className="wrapper">
                        <Gallery />
                    </div>
                </div>
            </main>

            <Footer />
        </Fragment>
    );
};

export default Portfolio;
